export default __webpack_public_path__ + "static/media/Provider.8d49c6b0.xlsx";